import { getQueryParamFromSrcScript } from 'utils/domHelpers';
import { handleError } from 'utils/errorHandler';
import { initializeV1Script } from 'v1/index';
import { SupportClient } from 'v2/clients/supportClient';
import { initializeV2Script } from 'v2/index';

export const initializeScript = async () => {
  try {
    const supportClient = new SupportClient();

    const scope = getQueryParamFromSrcScript('scope');

    if (!scope) {
      throw new Error('Scope was not provided');
    }

    const {
      is_messaging_enabled: isMessagingEnabled,
      integration_key: integrationKey,
    } = await supportClient.getChatConfig(scope);

    if (isMessagingEnabled) {
      initializeV2Script({ integrationKey, supportClient, scope });
    } else {
      initializeV1Script({ integrationKey });
    }
  } catch (error) {
    handleError(error);
  }
};
